import { memo } from 'react'

import { UploadPrimitive } from 'modules/documents/upload-primitive'

import type { TUploadButtonViewProps } from './upload-button.types'
import './upload-button.styles.scss'

const Component = ({ children, ...props }: TUploadButtonViewProps) => {
  return (
    <button {...props} type="button" className="UploadButton">
      <UploadPrimitive>{children}</UploadPrimitive>
    </button>
  )
}

export const UploadButtonView = memo(Component)
